module.exports = "https://www.niulinkcloud.com/_next/static/media/official.216133aa89bb46916645bdf667342289.jpg";